import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ProductCard from "../product/ProductCard";

const ProductRailSection = ({
  eyebrow,
  title,
  description,
  products = [],
  to = "/shop",
  cta = "View All",
  testId,
  loading = false,
  limit = 5,
  alwaysShow = false,
  emptyMessage = "Products are loading. Please check back in a moment.",
}) => {
  const visibleProducts = products.slice(0, limit);
  const showSkeletons = loading && visibleProducts.length === 0;

  if (!alwaysShow && !showSkeletons && visibleProducts.length === 0) return null;

  return (
    <section className="px-4 py-7 md:px-8 md:py-10 lg:px-12" data-testid={testId}>
      <div className="mb-4 flex items-end justify-between gap-4 md:mb-6">
        <div className="max-w-2xl">
          <span className="font-mono text-[10px] uppercase tracking-[0.26em] text-cynos-red md:text-xs">
            {eyebrow}
          </span>
          <h2 className="mt-2 font-anton text-[clamp(2rem,8vw,3rem)] uppercase leading-none md:text-5xl">
            {title}
          </h2>
          {description && (
            <p className="mt-2 max-w-xl text-sm leading-6 text-zinc-400 md:text-[15px]">
              {description}
            </p>
          )}
        </div>
        <Link
          to={to}
          className="hidden min-h-[44px] items-center gap-2 rounded-[8px] border border-white/15 px-5 font-mono text-[11px] uppercase tracking-[0.18em] transition hover:border-white hover:text-cynos-red md:inline-flex"
        >
          {cta} <ArrowRight size={14} />
        </Link>
      </div>

      <div className="grid auto-rows-fr grid-cols-1 gap-3 min-[390px]:grid-cols-2 md:grid-cols-3 md:gap-2.5 lg:grid-cols-4 lg:gap-2.5 min-[1440px]:grid-cols-5 min-[1440px]:gap-2.5">
        {showSkeletons
          ? [...Array(limit)].map((_, index) => (
              <div key={index} className="overflow-hidden rounded-[8px] border border-white/10 bg-cynos-card">
                <div className="aspect-[4/5] animate-pulse bg-cynos-surface" />
                <div className="space-y-3 p-3">
                  <div className="h-4 w-5/6 animate-pulse rounded bg-white/10" />
                  <div className="h-4 w-1/3 animate-pulse rounded bg-white/10" />
                  <div className="h-11 animate-pulse rounded-[8px] bg-white/10" />
                </div>
              </div>
            ))
          : visibleProducts.length > 0
            ? visibleProducts.map((product) => <ProductCard key={product.id} product={product} />)
            : (
                <div className="col-span-full rounded-[8px] border border-white/10 bg-cynos-card px-4 py-8 text-center font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-500">
                  {emptyMessage}
                </div>
              )}
      </div>

      <Link
        to={to}
        className="mt-4 inline-flex min-h-[46px] w-full items-center justify-center gap-2 rounded-[8px] border border-white/15 font-mono text-[11px] uppercase tracking-[0.18em] transition hover:border-white md:hidden"
      >
        {cta} <ArrowRight size={14} />
      </Link>
    </section>
  );
};

export default ProductRailSection;
